<mat-toolbar>
  <span>{{title}}</span>
  <span class="spacer"></span>
  @if (isLoggedIn() | async; as user) {
    <div>
      <button mat-icon-button [routerLink]="'hits'"><mat-icon>list</mat-icon></button>
      <button mat-icon-button [routerLink]="'map'"><mat-icon>map</mat-icon></button>
      @if (user) {
        <img slot="start" class="avatar" [src]="user.photoURL" title="{{user.displayName}} ({{user.email}})" referrerpolicy=“no-referrer”/>
      }
      <button mat-icon-button (click)="logout()"><mat-icon>logout</mat-icon></button>
    </div>
  } @else {
    <button  mat-raised-button (click)="login()">Login</button>
  }
</mat-toolbar>
<router-outlet></router-outlet>
